export const isWX = function () {
  const ua = window.navigator.userAgent.toLowerCase()
  return ua.match(/MicroMessenger/i) && ua.match(/MicroMessenger/i)[0] === 'micromessenger'
}

export const isAlipay = function () {
  const ua = window.navigator.userAgent.toLowerCase()
  return ua.match(/Alipay/i) && ua.match(/Alipay/i)[0] === 'alipay'
}

export const checkBrowser = function () {
  if (isWX()) {
    return 'WECHAT'
  }
  if (isAlipay()) {
    return 'ALIPAY'
  }
  return process.env.NODE_ENV === 'development' ? 'WECHAT' : 'APP'
}
export const isAndroid = function () {
  const ua = window.navigator.userAgent.toLowerCase()
  return ua.indexOf('android') > -1 || ua.indexOf('adr') > -1
}

export const isiOS = function () {
  const ua = window.navigator.userAgent.toLowerCase()
  return ua.indexOf('iphone') > -1 || ua.indexOf('mac') > -1
}

export const isPC = function () {
  const ua = window.navigator.userAgent.toLowerCase()
  const Agents = ['Android', 'iPhone', 'webOS', 'BlackBerry', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod']
  // eslint-disable-next-line no-unused-vars
  for (let item of Agents) {
    item = item.toLowerCase()
    if (ua.includes(item)) {
      return false
    }
  }
  return true
}
